// eslint-disable-next-line import/prefer-default-export
export const US = 'US'
export const MX = 'MX'
export const BO = 'BO'
export const BR = 'BR'
export const CL = 'CL'
export const EC = 'EC'
export const PE = 'PE'
export const UY = 'UY'
export const VE = 'VE'
export const SV = 'SV'
export const HN = 'HN'
export const PA = 'PA'
export const CR = 'CR'
export const GT = 'GT'
export const NI = 'NI'
export const GD = 'GD'
export const GY = 'GY'
export const GF = 'GF'
export const HT = 'HT'
export const JM = 'JM'
export const PY = 'PY'
export const PR = 'PR'
export const SR = 'SR'
export const DO = 'DO'
export const CU = 'CU'
export const AT = 'AT'
export const HR = 'HR'
export const CY = 'CY'
export const CZ = 'CZ'
export const DK = 'DK'
export const EE = 'EE'
export const FI = 'FI'
export const HU = 'HU'
export const IE = 'IE'
export const IT = 'IT'
export const LV = 'LV'
export const LT = 'LT'
export const LU = 'LU'
export const MT = 'MT'
export const BE = 'BE'
export const BG = 'BG'
export const FR = 'FR'
export const DE = 'DE'
export const GR = 'GR'
export const NL = 'NL'
export const NO = 'NO'
export const PL = 'PL'
export const PT = 'PT'
export const RO = 'RO'
export const SK = 'SK'
export const SI = 'SI'
export const ES = 'ES'
export const SE = 'SE'
export const LI = 'LI'
export const IS = 'IS'


export const LATAM_COUNTRIES = [
  BO,
  BR,
  CL,
  EC,
  PE,
  UY,
  VE,
  SV,
  HN,
  PA,
  CR,
  GT,
  NI,
  GD,
  GY,
  GF,
  HT,
  JM,
  PY,
  PR,
  SR,
  DO,
  CU,
]

export const GDPR_COUNTRIES = [
  AT,
  BE,
  BG,
  BR,
  HR,
  CY,
  CZ,
  DK,
  EE,
  FI,
  FR,
  DE,
  GR,
  HU,
  IE,
  IT,
  LV,
  LT,
  LU,
  MT,
  NL,
  NO,
  PL,
  PT,
  RO,
  SK,
  SI,
  ES,
  SE,
  LI,
  IS,
]
